/**
 * Viewport breakpoints for the Flow Studio shell. This is the single source for the JS side.
 * The CSS media queries repeat these numbers (as max-width 767px and min-width 1024px), and
 * layoutContracts.test.ts fails if they drift from the values here.
 *
 * Below MOBILE_MAX_WIDTH: phone (drawer). From MOBILE_MAX_WIDTH up to DESKTOP_MIN_WIDTH: tablet
 * (drawer). From DESKTOP_MIN_WIDTH up: desktop (sidebar can stay open).
 */
export const MOBILE_MAX_WIDTH = 768;
export const DESKTOP_MIN_WIDTH = 1024;
